import { Trans, t } from "@lingui/macro";
import { Meter } from "@carbon/icons-react";
import OnboardingHeader from "@/components/Onboarding/OnboardingHeader";
import { Button } from "@mui/material";
import SetUpPacesDrawer from "./SetUpPacesDrawer";
import { Box, Container } from "@mui/system";
import useSetUpPaces from "./useSetUpPaces";

function SetUpPaces() {
  const {
    setupPacesDrawerOpen,
    handleOpen,
    handleClose,
    handleSkip,
    yourPaceZones,
    setYourPaceZones,
    showResultPage,
    setShowResultPage,
    handleBackFromResult,
    handleSave,
  } = useSetUpPaces({ closeAfterSave: false });

  return (
    // Flex column at a fixed height so the header gets its own scroll region and the
    // action buttons stay pinned to the bottom. mt="auto" alone did nothing here: the
    // Container was not a flex parent, so the buttons sat in flow under the header.
    <Container
      maxWidth="sm"
      disableGutters
      sx={{ height: "100%", display: "flex", flexDirection: "column" }}
    >
      <Box flex={1} minHeight={0} overflow="auto" width="100%">
        <OnboardingHeader
          Icon={Meter}
          title={t`Let’s set up your paces`}
          subtitle={t`Setting up your paces will help us ensure your workouts and training data are tailored to you.`}
        />
      </Box>
      <SetUpPacesDrawer
        open={setupPacesDrawerOpen}
        handleClose={handleClose}
        yourPaceZones={yourPaceZones}
        setYourPaceZones={setYourPaceZones}
        showResultPage={showResultPage}
        setShowResultPage={setShowResultPage}
        handleBackFromResult={handleBackFromResult}
        handleSave={handleSave}
      />
      <Box
        display="flex"
        flexDirection="column"
        rowGap={1}
        px={3}
        pt={2}
        pb="var(--wf-bottom-safe-area, 0px)"
        width="100%"
        maxWidth={"sm"}
      >
        <Button variant="contained" size="large" fullWidth onClick={handleOpen}>
          <Trans>Set Up Paces</Trans>
        </Button>
        <Button variant="contained" color="secondary" size="large" fullWidth onClick={handleSkip}>
          <Trans>Skip</Trans>
        </Button>
      </Box>
    </Container>
  );
}

export default SetUpPaces;
